import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import { Header } from 'scenes/Cashflow/styles'
import styled from 'styled-components'
import { color } from 'utils'

import { AddressWrapper, CryptoWrapper } from '../styles'

export const Divider = styled.div`
  width: 540px;
  height: 1px;
  background-color: ${color('dark500')};
  position: absolute;
  left: 0;
`

export const StyledDivider = styled(Divider)`
  background-color: ${color('dark700')};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledAddressWrapper = styled(AddressWrapper)`
  margin-top: 2.5rem;
`

export const StyledCryptoWrapper = styled(CryptoWrapper)`
  margin-top: 5rem;
`

export const StyledHeader = styled(Header)`
  margin-bottom: 2.5rem;
`

export const MessageInline = styled.div`
  background-color: ${color('dark800')};
  width: 30px;
  text-align: center;
`

export const SytledColumn = styled(Column)`
  margin-top: 2.5rem;
`

export const StyledCeruleanButton = styled(CeruleanButton)`
  width: 100%;
`

export const Empty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20vh;
`
